import axiosInstance from './axiosInstance';

/**
 * Document Assessment API — reads the EasyFlex document-classification data
 * that lives in central-db, proxied through optima-backend. Powers the
 * Document Assessment tab (coverage overview + drill-down to workers).
 */

export interface DocTypeCoverage {
    inferredDocType: string;
    documents: number;
    workersWithAny: number;
    workersWithValid: number;
    recruitmentRelevant: number;
}

export interface DocCoverageStats {
    organizationName: string;
    totalWorkers: number;
    byType: DocTypeCoverage[];
}

export type DocStatus = 'valid' | 'expired' | 'missing';

export interface WorkerDocRef {
    easyflexDocumentNumber: number;
    fileName: string | null;
    validUntil: string | null;
    inferredValidUntil: string | null;
}

export interface WorkerByDocStatus {
    workerRegistrationNumber: number;
    firstName: string | null;
    lastName: string | null;
    documents: WorkerDocRef[];
}

export interface WorkersByDocStatusResponse {
    organizationName: string;
    inferredDocType: string;
    status: string;
    count: number;
    workers: WorkerByDocStatus[];
}

export const fetchDocCoverageStats = async (
    organization?: string,
): Promise<DocCoverageStats> => {
    const response = await axiosInstance.get<{ status: string; data: DocCoverageStats }>(
        '/workers/easyflex/documents/stats',
        { params: organization ? { organization } : {} },
    );
    return response.data.data;
};

export const fetchWorkersByDocStatus = async (
    inferredDocType: string,
    status: DocStatus,
    organization?: string,
): Promise<WorkersByDocStatusResponse> => {
    const response = await axiosInstance.get<{ status: string; data: WorkersByDocStatusResponse }>(
        '/workers/easyflex/documents/workers-by-status',
        { params: { inferredDocType, status, ...(organization ? { organization } : {}) } },
    );
    return response.data.data;
};
